module.exports = __webpack_public_path__ + "static/img/10.bd0a8539.png";